import { useEffect, useState } from "react";
import api from "../lib/api";
import { Hash, X } from "lucide-react";

/**
 * HashtagPicker — controls a list of 15 trending hashtags. Insists user picks from the list.
 * Props: open (bool), onClose, onPick(tag) — invoked with the hashtag string (incl. #)
 */
export default function HashtagPicker({ open, onClose, onPick }) {
  const [tags, setTags] = useState([]);
  useEffect(() => {
    if (open && tags.length === 0) {
      api.get("/hashtags/trending").then(r => setTags(r.data?.hashtags || []));
    }
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[90] bg-black/80 backdrop-blur-sm flex items-end justify-center" data-testid="hashtag-picker"
      onClick={onClose}>
      <div className="w-full max-w-md rounded-t-3xl border border-white/10 bg-[#0B0F19] p-5 max-h-[70vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <Hash className="w-5 h-5 text-[#00E5FF]"/>
            <h3 className="font-outfit font-extrabold text-lg">Pick a trending hashtag</h3>
          </div>
          <button onClick={onClose} data-testid="hashtag-picker-close" className="p-1.5 rounded-full hover:bg-white/10">
            <X className="w-5 h-5"/>
          </button>
        </div>
        <p className="text-xs text-white/60 mb-4">Tap any trending tag to add it to your caption. You can also write your own custom hashtags directly in the caption.</p>
        <div className="grid grid-cols-2 gap-2" data-testid="hashtag-grid">
          {tags.map(t => (
            <button key={t} type="button" onClick={() => { onPick(t); onClose(); }}
              data-testid={`hashtag-${t.replace(/[#]/g,"")}`}
              className="px-3 py-2.5 rounded-xl border border-white/10 bg-white/5 hover:border-[#00E5FF] hover:bg-[#00E5FF]/10 text-left text-sm font-bold text-[#00E5FF] active:scale-95 transition">
              {t}
            </button>
          ))}
        </div>
        <p className="text-[10px] text-center text-white/40 mt-4">Tip: combine 3-5 hashtags to maximize reach across the Hifireels feed.</p>
      </div>
    </div>
  );
}
